import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { contentTerms } from "./Content";
import { contentPermission } from "./PermissionContent";
import ReactHtmlParser from "react-html-parser";
import "./Automation.css";
import { automationProcessContent } from "./AutomationProcess";
import { appDirectoryContent } from "./AppDirectoryContent";
import VideoContainer from "../common/VideoContainer";
import ImageContainer from "../common/ImageContainer";
import { automationTool } from "./AutomationTool";

const CONTENT_MAP = {
  "ai-agents-guide": contentTerms,
  "ai-agents-permissions": contentPermission,
  "ai-agent": automationProcessContent,
  "ai-agents-how-to-integrate-app": appDirectoryContent,
  "ai-agents-tools": automationTool,
};

const AutomationLayoutPage = () => {
  const { pageType } = useParams();
  const { pathname } = useLocation();
  const section = pathname.split("/")[1];

  const contentSource = CONTENT_MAP[section] || {};
  const content = contentSource[pageType];

  if (!content) {
    return <div>Page not found</div>;
  }

  const transform = (node, index) => {
    if (node.type === "tag") {
      if (node.name === "video-component") {
        const { src } = node.attribs || {};
        return <VideoContainer key={index} src={src} />;
      }
  
      if (node.name === "image-component") {
        const { src, alt } = node.attribs || {};
        return <ImageContainer key={index} src={src} alt={alt} />;
      }
    }
  };

  return (
    <div className="ai-agent-container">
      <h2 className="headingTwo">{content.title}</h2>
      <div>{ReactHtmlParser(content.content, { transform })}</div>
    </div>
  );
};

export default AutomationLayoutPage;